import { DraftParagraphLockEnum } from "@app_schema";

// Why a part of his Report stays as it is in his Word file, as its tip says.
export const LOCK_TIPS: Record<DraftParagraphLockEnum, string | null> = {
  [DraftParagraphLockEnum.Table]:
    "Tables stay as they are in your Word file. Change them in Word.",
  [DraftParagraphLockEnum.TextBox]:
    "Text boxes stay as they are in your Word file.",
  [DraftParagraphLockEnum.Field]:
    "This is a Word field (a page number or date). Word fills it in.",
  [DraftParagraphLockEnum.TrackedChange]:
    "This paragraph has tracked changes. Accept or reject them in Word first.",
  [DraftParagraphLockEnum.Other]:
    "This paragraph has Word content, like a link or a footnote, that stays as it is. Change it in Word.",
  [DraftParagraphLockEnum.Missing]: "Your report changed. Reload to see it.",
  // A section's own block: its label and menu speak for it.
  [DraftParagraphLockEnum.Section]: null,
};

export const HEADER_TIP =
  "Headers and footers stay as they are in your Word file.";
export const WRITING_TIP =
  "Writing this section. You can edit the rest of the report.";
